import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "72",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "72",
      height: "72",
      fill: "#FBBC04",
      rx: "36"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#191E23",
      d: "M36 36.203a5.4 5.4 0 0 0 2.984-.875 6.36 6.36 0 0 0 2.188-2.36q.813-1.5.812-3.359 0-1.812-.828-3.265a6.2 6.2 0 0 0-2.172-2.297A5.55 5.55 0 0 0 36 23.203a5.53 5.53 0 0 0-2.984.86 6.3 6.3 0 0 0-2.172 2.328q-.813 1.453-.813 3.25 0 1.828.813 3.328a6.4 6.4 0 0 0 2.172 2.36 5.4 5.4 0 0 0 2.984.874M26.203 49.97H45.47a2.6 2.6 0 0 1-.25-1.125v-5.36a5.6 5.6 0 0 1-1.86-2.687q-1.437-.89-3.297-1.438-1.86-.546-4.062-.547-2.875 0-5.188.86t-3.953 2.234q-1.624 1.36-2.5 2.938-.875 1.562-.875 2.984 0 1.016.72 1.578.717.563 2 .563Zm22.875-16.657q-1.266 0-2.312.626a4.7 4.7 0 0 0-1.657 1.64 4.4 4.4 0 0 0-.609 2.281q0 1.438.75 2.578a4.46 4.46 0 0 0 2.063 1.672v6.735q0 .28.25.531l1.203 1.188a.48.48 0 0 0 .328.124q.188.016.343-.14l2.188-2.188a.494.494 0 0 0 0-.718l-1.219-1.25 1.735-1.72a.5.5 0 0 0 .156-.358.52.52 0 0 0-.172-.376l-1.688-1.687q1.547-.672 2.376-1.813.843-1.14.843-2.578a4.3 4.3 0 0 0-.625-2.28 4.55 4.55 0 0 0-1.656-1.642 4.35 4.35 0 0 0-2.297-.624Zm-.016 2.11q.579 0 .985.406t.406.969a1.36 1.36 0 0 1-1.39 1.39 1.36 1.36 0 0 1-1.375-1.39q0-.562.406-.969.405-.406.968-.406"
    }, null, -1)
  ])))
}
export default { render: render }